import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserActions from '../../actions/user/user-actions'
import GameActions from '../../actions/game/game-actions'
import UIActions from '../../actions/ui/ui-actions'
import NewGameCP from './NewGameCP'
import GameSidebarCP from '../game/GameSidebarCP'

import MainColCP from '../structure/MainColCP'
import FoldoutCP from '../common/displaySchema/FoldoutCP'
import CopyrightIcon from '@material-ui/icons/Copyright'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import './overview-cp.css'


class OverviewCP extends Component {
  constructor () {
    super()

    // this.state = {}
  }

  // componentDidMount () {
  //   var fRet = this.props.getFriends()
  //   this.props.getGames()
  // }
  onToggleInviteFoldout (event, isOpen) {
    this.props.setInviteTab(isOpen)
  }

  onToggleActiveFoldout (event, isOpen) {
    this.props.setActiveTab(isOpen)
  }

  onTogglePastFoldout (event, isOpen) {
    this.props.setPastTab(isOpen)
  }

  onJoinInvite (event, gameId) {
    this.props.setGameInviteStatus(gameId, 'ACTIVE')
  }

  onDeclineInvite (event, gameId) {
    this.props.setGameInviteStatus(gameId, 'DECLINED')
  }

  onOpenGame (event, gameId) {
    this.props.loadGame(gameId)
  }

  render () {
    if (!this.props.constants || !Object.keys(this.props.gameTypes).length) return null

    let inviteGames = this.renderGames(this.props.games, this.props.constants.game_status.INVITE)
    let activeGames = this.renderGames(this.props.games, this.props.constants.game_status.ACTIVE)
    let completedGames = this.renderGames(this.props.games, this.props.constants.game_status.COMPLETED)

    let gameMoveHistory = null
    if (this.props.gameId) gameMoveHistory = (
      <GameSidebarCP />
    )
    
    return (
      <>
        <MainColCP className='main-col-friends' title='friends'>
          {this.renderUsers(this.props.friends)}
        </MainColCP>
        <MainColCP className='main-col-games' title='games'>
          <NewGameCP className='sectItem'></NewGameCP>
          <div className='spacerEle'></div>
          <FoldoutCP displayName={`Games Invites ${inviteGames.length}`}
            isOpen={this.props.isInviteTabOpen} 
            onClick={(event, isOpen) => this.onToggleInviteFoldout(event, isOpen)}
          >
            {inviteGames}
          </FoldoutCP>
          <div className='spacerEle'></div>
          <FoldoutCP displayName={`Active Games ${activeGames.length}`}
            isOpen={this.props.isActiveTabOpen} 
            onClick={(event, isOpen) => this.onToggleActiveFoldout(event, isOpen)}
          >
            {activeGames}
          </FoldoutCP>
          <div className='spacerEle'></div>
          <FoldoutCP displayName={`Past Games ${completedGames.length}`}
            isOpen={this.props.isPastTabOpen} 
            onClick={(event, isOpen) => this.onTogglePastFoldout(event, isOpen)}
          >
            {completedGames}
          </FoldoutCP>
        </MainColCP>
        {gameMoveHistory}
      </>
    )
  }


  // will be own component
  renderUsers (users) {
    var jsx = []
    Object.values(users).forEach(user => {
      jsx.push(this.renderUserRow(user))
    })
    return jsx
  }

  renderUserRow (user) {
    return (
      <div key={`user_${user.id}`}>
        {user.name}
      </div>
    )
  }

  // make own component
  renderGames (games, filterStatus) {
    let jsx = []
    let gameList = Object.values(games)
    gameList.sort((a, b) => b.created_time - a.created_time)
    gameList.forEach(game => {
      if (!filterStatus || filterStatus === game.status){
        jsx.push(this.renderGameRow(game, filterStatus))
      }
    })
    if (jsx.length <= 0) {
      jsx.push(
        <div className='sectItem' key='game_none'>
          none
        </div>
      )
    }
    return jsx
  }

  renderGameRow (game, filterStatus) {
    // TODO: move this?
    let dateOptions = {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
    }
    let gameTime = new Intl.DateTimeFormat('en-US', dateOptions).format( new Date(game.created_time * 1000) )
    var userJsx = []
    var btnJsx = []
    // ToDo: render users in order of status:
    //  (this user) then ['CREATOR', 'ACTIVE', 'INVITE', 'DECLINED']
    // ToDo: when starting a game delete users that have declined or have not yet accepted the invite
    let statusOrder = {
      'CREATOR': 1,
      'ACTIVE': 2, 
      'INVITE': 3, 
      'DECLINED': 4,
    }
    let thisUser = {}
    let users = [...game.users]
    users.sort((a, b) => statusOrder[a.status] - statusOrder[b.status])
    users.forEach(user => {
      if (user.id === this.props.userId) thisUser = user
      userJsx.push(this.renderGameUserItem(game.id, user))
    })
    if (this.props.constants.game_status.INVITE === filterStatus) {
      btnJsx = [
        <button className='bcioButton inlineSpacer' role='' key='joinBtn' 
          disabled={(thisUser.status === 'CREATOR' || thisUser.status === 'ACTIVE')}
          onClick={event => this.onJoinInvite(event, game.id)} 
        >join</button>,
        <button className='bcioButton inlineSpacer' role='' key='declineBtn' 
          disabled={(thisUser.status === 'CREATOR' || thisUser.status === 'DECLINED')}
          onClick={event => this.onDeclineInvite(event, game.id)} 
        >decline</button>
      ]
    } else if (
      this.props.constants.game_status.ACTIVE === filterStatus
      || this.props.constants.game_status.COMPLETED === filterStatus
    ) {
      btnJsx = [
        <button className='bcioButton inlineSpacer' role='' key='openBtn' onClick={event => this.onOpenGame(event, game.id)} >open</button>
      ]
    }
    return (
      <div className='sectItem' key={`game_${game.id}`}>
        <div>
          {this.props.gameTypes[game.type].display_name} | {game.name} | {gameTime}
        </div>
        <div>
          {btnJsx}
          {userJsx}
        </div>
      </div>
    )
  }

  renderGameUserItem (gameId, user) {
    // TODO: move this?
    const iconsByStatus = {
      'CREATOR': <CopyrightIcon className='inline-icon color-good-to-go' />, 
      'ACTIVE': <CheckIcon className='inline-icon color-good-to-go' />, 
      'INVITE': <HelpOutlineIcon className='inline-icon color-unknown' />, 
      'DECLINED': <ClearIcon className='inline-icon color-nope' />,
    }
    let icon = iconsByStatus[user.status]
    return (
      <span key={`gameUser_${gameId}_${user.id}`} className='inlineSpacer'>-{user.name}{icon}</span>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    constants: state.system.constants,
    userId: state.user.user.id,
    friends: state.user.friends,
    games: state.user.games,
    serverTimeOffset: state.system.serverTimeOffset,
    gameTypes: state.system.gameTypes,
    gameId: state?.game?.gameState?._id,
    isInviteTabOpen: state.ui.isInviteTabOpen,
    isActiveTabOpen: state.ui.isActiveTabOpen,
    isPastTabOpen: state.ui.isPastTabOpen,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // getFriends: () => {
    //   const freinds = UserActions.getFriends()
    //   console.log(dispatch(freinds))
    //   return freinds
    // },
    //getGames: () => dispatch(UserActions.getGames()),
    setGameInviteStatus: (gameId, status) => dispatch(UserActions.setGameInviteStatus(gameId, status)),
    loadGame: (gameId) => dispatch(GameActions.loadGame(gameId)),
    setInviteTab: isTabOpen => dispatch(UIActions.setInviteTab(isTabOpen)),
    setActiveTab: isTabOpen => dispatch(UIActions.setActiveTab(isTabOpen)),
    setPastTab: isTabOpen => dispatch(UIActions.setPastTab(isTabOpen)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OverviewCP)
